// src/utils/auth.js
// Utility to get current user role from JWT

export function getUserRole() {
  const token = localStorage.getItem('jwt');
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role || null;
  } catch {
    return null;
  }
}

// Best-effort extraction of a stable user identifier from the JWT
export function getUserId() {
  const token = localStorage.getItem('jwt');
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // Common claim names: userId, id, sub, email
    return payload.userId || payload.id || payload.sub || payload.email || null;
  } catch {
    return null;
  }
}
